// @ts-check
import apiClient from "./apiClient";

/**
 * @template T
 * @param {{ limit?: number; offset?: number; q?: string; sort?: string }} params
 * @returns {Record<string, any>}
 */
const buildListParams = (params = {}) => {
  const result = {};
  if (params.limit !== undefined) result.limit = params.limit;
  if (params.offset !== undefined) result.offset = params.offset;
  if (params.q !== undefined) result.q = params.q;
  if (params.sort !== undefined) result.sort = params.sort;
  return result;
};

/**
 * @param {{ limit?: number; offset?: number; q?: string; sort?: string }} params
 * @returns {Promise<import("./types").PaginatedResponse<import("./types").FrameworkRead>>}
 */
export async function getFrameworks(params = {}) {
  const response = await apiClient.get("/frameworks", { params: buildListParams(params) });
  return response.data;
}

/**
 * @param {number} id
 * @returns {Promise<import("./types").FrameworkRead>}
 */
export async function getFramework(id) {
  const response = await apiClient.get(`/frameworks/${id}`);
  return response.data;
}

/**
 * @param {import("./types").FrameworkCreate} data
 * @returns {Promise<import("./types").FrameworkRead>}
 */
export async function createFramework(data) {
  const response = await apiClient.post("/frameworks", data);
  return response.data;
}

/**
 * @param {number} id
 * @param {import("./types").FrameworkUpdate} data
 * @returns {Promise<import("./types").FrameworkRead>}
 */
export async function updateFramework(id, data) {
  const response = await apiClient.patch(`/frameworks/${id}`, data);
  return response.data;
}

/**
 * @param {number} id
 * @returns {Promise<void>}
 */
export async function deleteFramework(id) {
  await apiClient.delete(`/frameworks/${id}`);
}
